import React, { useState, useEffect } from "react";
import { HashRouter, Route, Routes, useLocation } from "react-router-dom";
import Login from "./Pages/Login";
import ForgotPassword from "./Components/ForgotPassword";
import Home from "./Pages/Home";
import Profile from "./Pages/Profile";
import AppField from "./Pages/AppField";
import Documents from "./Pages/Documents";
import Charts from "./Pages/Charts";
import Forecast from "./Pages/Forecast";
import Notes from "./Pages/Notes";
import AdminNotes from "./Pages/AdminNotes";
import FieldNotes from "./Pages/FieldNotes";
import Compare from "./Pages/Compare";
import Forms from "./Pages/Forms";

import Dashboard from "./Pages/Dashboard/Dashboard";
import DashLogin from "./Pages/Dashboard/DashLogin";
import Instances from "./Pages/Dashboard/Instances";
import Users from "./Pages/Dashboard/Users";

import AddNotes from "./Components/AddNotes";
import EditNotes from "./Components/EditNotes";
import AddSubnote from "./Components/AddSubnote";
import EditSubnote from "./Components/EditSubnote";
import Results from "./Components/Results";
import Statement from "./Components/Statement";
import PrivateRoutes from "./Components/PrivateRoutes";
import Search from "./Components/Search";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname, location.hash]);

  return null;
};
function App() {
  const [currentHash, setCurrentHash] = useState(typeof window !== "undefined" ? window.location.hash || "#/" : "#/");

  useEffect(() => {
    const handleHashChange = () => {
      setCurrentHash(window.location.hash || "#/");
    };

    window.addEventListener("hashchange", handleHashChange);
    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  useEffect(() => {
    const applyDefaultTheme = () => {
      document.documentElement.style.setProperty("--brand-color", "#0f3d9a");
      document.documentElement.style.setProperty("--brand-secondary-color", "#4f6bd7");
      document.documentElement.style.setProperty("--secondary-color", "#4f6bd7");
      document.documentElement.style.setProperty("--brand-active-text-color", "#14223a");
      document.documentElement.style.setProperty("--active-text-color", "#14223a");
    };

    applyDefaultTheme();

    const normalizedPath = (() => {
      if (!currentHash) return "/";
      const hash = currentHash.startsWith("#") ? currentHash.slice(1) : currentHash;
      const path = hash.split("?")[0] || "/";
      return path || "/";
    })();

    const isPublicRoute =
      normalizedPath === "/" ||
      normalizedPath.startsWith("/ForgotPassword") ||
      normalizedPath.startsWith("/dashboard");

    if (isPublicRoute) {
      return;
    }

    const supplierToken = localStorage.getItem("token");
    const settings = localStorage.getItem("instance_settings");

    if (!supplierToken || !settings) {
      return;
    }

    try {
      const parsed = JSON.parse(settings);
      if (parsed.brandColor) {
        document.documentElement.style.setProperty("--brand-color", parsed.brandColor);
      }

      if (parsed.secondaryColor) {
        document.documentElement.style.setProperty("--brand-secondary-color", parsed.secondaryColor);
        document.documentElement.style.setProperty("--secondary-color", parsed.secondaryColor);
      }

      const activeTextColor = parsed?.active_text_color;
      if (activeTextColor) {
        const resolved = activeTextColor === 'dark' ? '#1e1e1e' : '#fff';
        document.documentElement.style.setProperty("--brand-active-text-color", resolved);
        document.documentElement.style.setProperty("--active-text-color", resolved);
      }
    } catch (e) {
      console.error("Error parsing instance_settings:", e);
      applyDefaultTheme();
    }
  }, [currentHash]);

  return (
    <div className="App">
      <HashRouter basename="/">
        <ScrollToTop />
        <Routes>

          {/* Administration Panel Starts Here */}
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/dashboard/login" element={<DashLogin />} />
            <Route path="/dashboard/instances" element={<Dashboard><Instances /></Dashboard>} />
            <Route path="/dashboard/users" element={<Dashboard><Users /></Dashboard>} />
          {/* Administration Panel Ends Here */}

          <Route element={<PrivateRoutes />}>
            <Route path="/Profile" exact element={<Profile />} />
            <Route path="/AppField" exact element={<AppField />} />
            <Route path="/Notes" exact element={<Notes />} />
            <Route path="/Notes/AddNotes" element={<AddNotes />} />
            <Route path="/Notes/EditNotes" element={<EditNotes />} />
            <Route path="/Notes/AddSubnote/:id" element={<AddSubnote />} />
            <Route path="/Notes/EditSubnote/:id" element={<EditSubnote />} />
          </Route>
          <Route path="/" element={<Login />} />
          <Route path="/Home" element={<Home />} />
          <Route path="/Field-Notes/:monthYear" element={<FieldNotes />} />
          <Route path="/ForgotPassword" element={<ForgotPassword />} />
          <Route path="/Documents" element={<Documents />} />
          <Route path="/Charts" element={<Charts />} />
          <Route path="/Compare" element={<Compare />} />
          <Route path="/Forms" element={<Forms />} />
          <Route path="/Forecast" element={<Forecast />} />
          <Route path="/AdminNotes" element={<AdminNotes />} />
          <Route path="/Results" element={<Results />} />
          <Route path="/Statement" element={<Statement />} />
          <Route path="/Statement/:monthYear" element={<Statement />} />
          <Route path="/Search" element={<Search />} />
        </Routes>
      </HashRouter>
      <ToastContainer />
    </div>
  );
}

export default App;
